import { DigestTemplatesResponse } from 'api/types';
import {DigestsActionTypes, DigestsAction} from 'store/types/digestsActionTypes';


interface StateTyp {
    isLoading: boolean;
    errorMessage: string;
    successMessage: string,
    digestTemplateCategories: string[],
    type: string
}

interface TemplateStateTyp {
    isLoading: boolean;
    errorMessage: string;
    successMessage: string,
    templates: DigestTemplatesResponse
    dist: number
    type: string
}

const initialState: StateTyp = {
    isLoading: false,
    errorMessage: '',
    successMessage: '',
    digestTemplateCategories: [],
    type: ''
};

interface TemplateStateTyp {
    isLoading: boolean;
    errorMessage: string;
    successMessage: string;
    templates: DigestTemplatesResponse
    dist: number
    type: string
}

const initialTemplateState: TemplateStateTyp = {
    isLoading: false,
    errorMessage: '',
    successMessage: '',
    templates: [],
    dist: 0,
    type: ''
};

export const digestsTemplatesCategories = (state = initialState, action: DigestsAction): StateTyp => {
    switch (action.type) {
        case DigestsActionTypes.FETCHING_DIGEST_TEMPLATES_CATEGORY:
            return {
                ...state,
                isLoading: true,
                digestTemplateCategories: [...action.payload],
            };
        default:
            return state;
    }
};

export const digestTemplates = (state = initialTemplateState, action: DigestsAction): TemplateStateTyp => {
    switch (action.type) {
        case DigestsActionTypes.FETCHING_DIGEST_TEMPLATES:
            return {
                ...state,
                isLoading: true,
                templates: [...action.payload.templates],
                dist:  action.payload.dist,
            };
        default:
            return state;
    }
};